/**
 * Extracted from sections/ns-faq-with-image.liquid (inline <script> at line 276).
 * Config bridge: window.__nsFaqWithImageSections, keyed by section id. The inline block
 * only needed Liquid for the section id, so the id is handed over as data
 * and the logic now runs from a cacheable, deferred asset instead of being
 * parsed and compiled during the HTML parse (INP work on the PDP).
 * Boots once per section id so multiple instances each initialise.
 */

(function () {
  var cfg = window.__nsFaqWithImageSections = window.__nsFaqWithImageSections || {};
  function boot(nsSectionId, nsSettings) {
      (function () {
        var root = document.getElementById(`shopify-section-${nsSectionId}`);
        if (!root) return;
        var items = Array.prototype.slice.call(root.querySelectorAll('[data-faqwi-item]'));
        if (!items.length) return;

        function setOpen(item, open) {
          item.classList.toggle('is-active', open);
          var toggle = item.querySelector('[data-faqwi-toggle]');
          if (toggle) toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        }

        items.forEach(function (item) {
          var toggle = item.querySelector('[data-faqwi-toggle]');
          if (!toggle) return;
          toggle.addEventListener('click', function () {
            var isOpen = item.classList.contains('is-active');
            items.forEach(function (other) {
              setOpen(other, other === item && !isOpen);
            });
          });
        });

        if (window.Shopify && window.Shopify.designMode) {
          root.addEventListener('shopify:block:select', function (event) {
            var item = event.target.closest('[data-faqwi-item]');
            if (!item) return;
            items.forEach(function (other) {
              setOpen(other, other === item);
            });
          });
        }
      })();
  
  }
  Object.keys(cfg).forEach(function (id) {
    var s = cfg[id];
    if (!s || s.__booted) return;
    s.__booted = true;
    boot(id, s);
  });
})();
